module.exports = __webpack_public_path__ + "static/media/thread.09f432c5.svg";